import Dexie, { EntityTable } from 'dexie';
import { AccountPlaylist } from './types';

export const playlistDB = new Dexie('PlaylistDatabase') as Dexie & {
  playlists: EntityTable<AccountPlaylist, 'id'>,
};

playlistDB.version(1).stores({
  playlists: '[accountID+id],accountID,id'
});
